const Constants = {
  DISTRIBUTER: {
    distributerID: "AHIBPL",
    contactEmail: "Contact@bajajcapital.com",
    loginUrlB2C: "https://dev.saving.insurance.1silverbullet.tech",
    loginUrlB2B: "https://dev.saving.insurance.1silverbullet.tech",
    distributorLogo:
      "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/AHI+LOGO-01+(2).jpg",
    distributorLogoDark:
      "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/AHI+LOGO-01+(2).jpg",
    contactNumber: "98111111111",
    startWithDark: false,
    "isHomeVisible": true,
    "isDashboardVisible": true,
    "isUserVisible": true,
    "sendQuote": false,
    defaultSelectedColumns: [
      { field: "journey_id", header: "Journey Id", style: "min-width:110px !important;", sortable: true, isFilter: true },
      { field: "proposal_manu_id", header: "Application Number", style: "max-width:120px !important;", sortable: true, isFilter: true },
      { field: "name", header: "Customer Name", style: "max-width:150px !important;", sortable: true, isFilter: true },
      { field: "insurance_company_code", header: "Insurance Company", style: "max-width:110px !important;", sortable: true, isFilter: true },
      { field: "created_at", header: "Proposal Initiate Date", style: "max-width:120px !important;", sortable: true, isFilter: false },
      { field: "total_premium", header: "Premium (₹)", style: "max-width:110px !important;", sortable: true, isFilter: false },
      { field: "transaction_date", header: "Payment Date", style: "max-width:120px !important;", sortable: true, isFilter: false },
      { field: "value", header: "Journey Status", style: "width:210px !important;", sortable: true, isFilter: true },
    ],
  },
  LAZY_LOADING: {
    inerval: "2000",
    nooftimes: "25",
  },
  LANDING_IMGS: {
    BIKE: "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/bike.svg",
    CAR: "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/Group+100+%284%29.svg",
    CARBG:
      "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/carbg.svg",
    BIKEBG:
      "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/bikebg.svg",
    BIKE_BG:
      "linear-gradient(180deg, hsla(133, 18%, 75%, 1) 0%, hsla(146, 20%, 79%, 1) 100%)",
    CAR_BG:
      "linear-gradient(180deg, hsla(30, 99%, 73%, 1) 0%, hsla(48, 99%, 65%, 1) 100%)",
    BANK: "https://insurance-manufacturer.s3.ap-south-1.amazonaws.com/logos/bank.svg",
  },
  IS_AUTO_COMPLETE: false,
  HAS_DARK_MODE: false,
  RM_DATA_UPLOAD_INSURER: [
    {
      name: "Select Insurer",
      value: "select",
    },
    {
      name: "ICICI Lombard",
      value: "IL",
    },
    {
      name: "Go Digit",
      value: "GODIGIT",
    },
  ],
  TEMPLATE_SETTING: {
    Email: true,
    Sms: true,
  },
  PREMIUM_BREAKUP: {
    basic_cover: [
      "tppd",
      "tpCngCvr",
      "paCvr",
      "paUnCvr",
      "paPdDvr",
      "legLibD",
      "legLibEm",
    ],
    Addons: [
      "zeroDep",
      "rsa",
      "engPrt",
      "conExp",
      "keyPrt",
      "rtnInv",
      "ncbPrt",
      "lossPerl",
      "tyrePrt",
      "fibGlass",
      "rimCvr",
      "wndSheld",
    ],
    Accessories: ["elCvr", "nonElCvr", "cngCvr"],
    Discount: ["volDed", "antiThft", "autoasso", "payAsDrv"],
  },
  PRODUCT_SELECTION: {
    "4W-Pvt": {
      "Roll-Over": [
        { name: "Package(1+1)", description: "Comprehensive" },
        { name: "StandaloneOD(1)", description: "Own Damage" },
        { name: "StandaloneTP(1)", description: "Third Party" },
      ],
      New: [
        { name: "Bundled(1+3)", description: "Bundled" },
        { name: "StandaloneTP(3)", description: "Third Party" },
      ],
    },
    "2W-Pvt": {
      "Roll-Over": [
        { name: "Package(1+1)", description: "Comprehensive" },
        { name: "StandaloneOD(1)", description: "Own Damage" },
        { name: "StandaloneTP(1)", description: "Third Party" },
      ],
      New: [
        { name: "Bundled(1+5)", description: "Bundled" },
        { name: "StandaloneTP(5)", description: "Third Party" },
      ],
    },
  },
  FOOTER_VISIBILITY: true,
  /** Dashboard table — parity with health `common.js`; default columns live on `DISTRIBUTER.defaultSelectedColumns`. */
  DASHBOARD_COLUMNS: [
    { field: "journey_id", header: "Journey Id", style: "min-width:110px !important;", sortable: true, isFilter: true },
    { field: "proposal_manu_id", header: "Application Number", style: "max-width:120px !important;", sortable: true, isFilter: true },
    { field: "name", header: "Customer Name", style: "max-width:150px !important;", sortable: true, isFilter: true },
    { field: "line_of_business", header: "Line of Business", style: "max-width:120px !important;", sortable: true, isFilter: true },
    { field: "insurance_company_code", header: "Insurance Company", style: "max-width:110px !important;", sortable: true, isFilter: true },
    { field: "mobile_number", header: "Mobile Number", style: "max-width:120px !important;", sortable: true, isFilter: true },
    { field: "created_at", header: "Proposal Initiate Date", style: "max-width:120px !important;", sortable: true, isFilter: false },
    { field: "total_premium", header: "Premium (₹)", style: "max-width:110px !important;", sortable: true, isFilter: false },
    { field: "transaction_date", header: "Payment Date", style: "max-width:120px !important;", sortable: true, isFilter: false },
    { field: "value", header: "Journey Status", style: "width:210px !important;", sortable: true, isFilter: true },
    { field: "user_name", header: "User Name", style: "max-width:120px !important;", sortable: true, isFilter: true },
    { field: "user_id", header: "User Id", style: "max-width:90px !important;", sortable: true, isFilter: true },
    { field: "role", header: "Role ID", style: "max-width:90px !important;", sortable: true, isFilter: true },
  ],
  ROLE_BASED_COLUMNS: {
    1: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    2: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    3: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value", "user_name", "user_id", "role"],
    4: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    5: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    6: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    7: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    8: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value"],
    9: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value", "user_name", "user_id", "role"],
    10: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value", "user_name", "user_id", "role"],
    11: ["journey_id", "proposal_manu_id", "name", "line_of_business", "insurance_company_code", "mobile_number", "created_at", "total_premium", "transaction_date", "value", "user_name", "user_id", "role"],
  },
};
Object.freeze(Constants);
export function getDistributer() {
  return Constants.DISTRIBUTER;
}
export function getIsAutoComplete() {
  return Constants.IS_AUTO_COMPLETE;
}
export function getLandingImgs() {
  return Constants.LANDING_IMGS;
}
//Get Lazy Load constants
export function getLazyLoadingConfig() {
  return Constants.LAZY_LOADING;
}
export function getRmDataUploadInsurer() {
  return Constants.RM_DATA_UPLOAD_INSURER;
}
export function hasDarkMode() {
  return Constants.HAS_DARK_MODE;
}

export function getTemplateSetting() {
  return Constants.TEMPLATE_SETTING;
}

export function getPremiumBreakup() {
  return Constants.PREMIUM_BREAKUP;
}

export function getProductSelection() {
  return Constants.PRODUCT_SELECTION;
}
export function getFooterVisibilty(){
  return Constants.FOOTER_VISIBILITY;
}

export function getConsumer() {
  return {
    defaultSelectedColumns: Constants.DISTRIBUTER.defaultSelectedColumns,
  };
}

export function getDashboardColumns() {
  return Constants.DASHBOARD_COLUMNS;
}

export function getRoleBasedColumns() {
  return Constants.ROLE_BASED_COLUMNS;
}